import { render, staticRenderFns } from "./sourceDetail.vue?vue&type=template&id=8f4207ec&scoped=true&"
import script from "./sourceDetail.vue?vue&type=script&lang=js&"
export * from "./sourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./sourceDetail.vue?vue&type=style&index=0&id=8f4207ec&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./sourceDetail.vue?vue&type=style&index=1&id=8f4207ec&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4207ec",
  null
  
)

export default component.exports